module.exports = __webpack_public_path__ + "media/images/como_funciona/choose-items-9c13a18ce11496d9c6590d327185e0e0.png";